import * as React from "react";
import clx from "clsx";
import Box from "../box";
import Text from "../text";
import type { BreadcrumbItemProps } from "./breadcrumb.types";
import * as styles from "./breadcrumb.css";

function BreadcrumbItem(props: BreadcrumbItemProps) {
  return (
    <Box
      display="flex"
      alignItems="center"
      fontWeight="$medium"
      lineHeight="$normal"
      textDecoration="none"
      as={props.as ?? "a"}
      gap={props.gapLeft}
      attributes={{
        href: props.href,
        download: props.download,
        ref: props.linkRef,
        target: props.target,
        type: props.type,
      }}
    >
      <Box
        as="span"
        whiteSpace={props.isLast ? "normal" : "nowrap"}
        className={clx({
          [styles.lineClamp]: props.isLast,
        })}
      >
        <Text
          as="span"
          fontSize="$md"
          color={{
            //@ts-expect-error
            base: props.isLast ? props.primaryColor : props.secondaryColor,
            //@ts-expect-error
            hover: props.primaryColor,
          }}
          className={clx({
            [styles.pointer]: props.isLast,
          })}
        >
          {props.name}
        </Text>
      </Box>
      {!props.isLast ? (
        <Text fontSize="$md" color={props.secondaryColor}>
          {props.separator}
        </Text>
      ) : null}
    </Box>
  );
}

BreadcrumbItem.defaultProps = {
  isLast: false,
  gapLeft: "16px",
  primaryColor: "$text",
  secondaryColor: "$textSecondary",
  separator: "/",
};

export default BreadcrumbItem;
